module.exports = __webpack_public_path__ + "static/media/img09.45f68436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/02/assets/img09.jpg
// module id = 362
// module chunks = 0